export class SidebarStateModel {
  collapsed?: boolean;
}

export class ToggleSidebar {
  static readonly type = '[Sidebar] ToggleSidebar';
  constructor(public collapsed: boolean) {}
}
